/* --------------------------- resize mobile 100vh -------------------------- */
const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty(
    "--app-height",
    `${document.documentElement.clientHeight}px`
  );
};
window.addEventListener("resize", appHeight);
appHeight();

$(document).ready(function () {
  /* ------------------------------ header scroll ----------------------------- */
  // scroll invert header
  if ($(".js-offset-top").length > 0) {
    $(window).on("pageshow scroll", function () {
      let hSize = $(".js-offset-top").offset().top - 10,
        scroll = $(window).scrollTop();

      scroll >= hSize
        ? $(".js-header-top").removeClass("c-header--white")
        : $(".js-header-top").addClass("c-header--white");
    });
  }

  // setHeight
  if ($(".js-mainvisual").length > 0) {
    function setHeight() {
      let footdivheight = $(".js-c-attention").height(),
        hSize = $(window).height(),
        heightVisual = hSize - footdivheight;

      $(".js-header-top").css("top", footdivheight);
      $(".js-mainvisual").css("height", heightVisual);
    }
    setHeight();
    $(window).resize(function () {
      setHeight();
    });
  }

  // handle close attention
  $(".js-close-attention").click(function () {
    $(this).parent().hide(), setHeight();
  });

  // scroll position
  if ($(".js-mainvisual").length > 0) {
    $(".js-header-top").css("position", "absolute");
    $(window).scroll(function () {
      let footdivheight = $(".c-attention").height(),
        hMain = $(".js-mainvisual").offset().top,
        scroll = $(window).scrollTop();

      scroll >= hMain
        ? ($(".js-header-top").css("top", 0),
          $(".js-header-top").css("position", "fixed"))
        : ($(".js-header-top").css("top", footdivheight),
          $(".js-header-top").css("position", "absolute"));
    });
  }
  /* --------------------------------- fadeout -------------------------------- */

  $(window).on("pageshow load", function () {
    $("body").removeClass("fadeout");
  });

  function detectOverlay(detect) {
    if (detect) {
      $(".js-overlay").addClass("is-visible");
      $(document.body).addClass("disable-scroll");
    } else {
      $(".js-overlay").removeClass("is-visible");
      $(document.body).removeClass("disable-scroll");
    }
  }

  $(".js-overlay").on("click", function () {
    $(".js-c-menu").removeClass("is-open");
    $(".js-c-search").removeClass("is-open");
    $(".js-c-cart").removeClass("is-open");
    detectOverlay(false);
  });

  /* ---------------------------------- menu ---------------------------------- */

  // toggle menu
  $(".js-btn-menu").on("click", function () {
    if ($(".js-c-menu").hasClass("is-open")) {
      $(".js-c-menu").removeClass("is-open");
      detectOverlay(false);
    } else {
      $(".js-c-menu").addClass("is-open");
      detectOverlay(true);
    }
  });

  // handle link menu
  $(".c-menu_link, .c-menu_bg").on("click", function () {
    $(".js-c-menu").removeClass("is-open");
    detectOverlay(false);
  });

  // toggle collapse
  let accordion = document.getElementsByClassName("js-collapse");
  let panel = document.getElementsByClassName("js-panel");
  for (let i = 0; i < accordion.length; i++) {
    accordion[i].addEventListener("click", function () {
      this.classList.toggle("open");
      if (panel[i].style.maxHeight) {
        panel[i].style.maxHeight = null;
      } else {
        panel[i].style.maxHeight = panel[i].scrollHeight + "px";
      }
    });
  }

  /* ---------------------------------- mega ---------------------------------- */

  $(".c-header .js-show-mega").hover(
    function () {
      $(".c-header").addClass("open-mega");
    },
    function () {
      $(".c-header").removeClass("open-mega");
    }
  ),
    $(window).scroll(function () {
      $(".c-header").removeClass("open-mega");
    });

  $(document).on("click", ".tab-link", function () {
    let tabID = $(this).attr("data-tab");

    $(this).addClass("active").siblings().removeClass("active");
    $("#tab-" + tabID)
      .addClass("active")
      .siblings()
      .removeClass("active");
  });

  /* --------------------------------- search --------------------------------- */

  // toggle search
  $(".js-btn-search").on("click", function () {
    if ($(".js-c-search").hasClass("is-open")) {
      $(".js-c-search").removeClass("is-open");
      detectOverlay(false);
    } else {
      $(".js-c-search").addClass("is-open");
      detectOverlay(true);
    }
  });

  /* ---------------------------------- cart ---------------------------------- */

  // toggle cart
  document.querySelectorAll(".js-btn-cart").forEach(function(button) {
    button.addEventListener("click", function(e) {
      e.preventDefault(); // Prevent the default anchor behavior
      
      const cartLink = document.querySelector("#cart-icon-bubble");
      
      // Create a MouseEvent instead of a generic Event
      var event = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      });
      
      // Dispatch the click event
      cartLink.dispatchEvent(event);
    });
  });


  /* ------------------------------- mainvisual ------------------------------- */

  const swiperMainvisual = new Swiper(".js-mainvisual-swiper", {
    effect: "fade",
    speed: 1200,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return (
          '<span class="' + className + '">' + "0" + (index + 1) + "</span>"
        );
      },
    },
    on: {
      init: doSomethingWithActiveSlide,
      slideChange: doSomethingWithActiveSlide,
    },
  });

  function doSomethingWithActiveSlide() {
    const mainvisualPagination = document.querySelector(
      ".mainvisual_swiper .swiper-pagination"
    );
    const mainvisualTitle = document.querySelectorAll(
      ".homepage .mainvisual_info"
    );

    mainvisualPagination.style.setProperty(
      "bottom",
      mainvisualTitle[this.activeIndex].offsetHeight + "px"
    );
  }

  /* ------------------------------- category tab ------------------------------- */
  let numberIndexCollection = 0;

  $(document).on("click", ".collection_tabs li", function () {
    numberIndexCollection = $(this).index();
    if (!$(this).is("active")) {
      $(".collection_tabs li").removeClass("active");
      $(".collection_thumbs li").removeClass("active");
      $(".collection_content").removeClass("active");

      // tab
      $(this).addClass("active");
      // content
      $(".collection_content:eq(" + numberIndexCollection + ")").addClass(
        "active"
      );
      $(".collection_thumbs li:eq(" + numberIndexCollection + ")").addClass(
        "active"
      );
    }
  });

  /* ------------------------------- handle tabs ------------------------------ */

  function handleTabChange(tab) {
    $(".js-nav-tab .is-indicator").css({
      width: tab.outerWidth(),
      left: tab.position() ? tab.position().left : 0,
    });
    tab = tab + 1;
  }
  
  function handleTabChangeHowto(tab, numIndex = 0) {
  const columns = 2; // c-tabs_nav ul の grid-template-columns の列数と合わせる
  const row = Math.floor(numIndex / columns);
  const offset = 0.6; // 微調整用：線を少し上にずらす
  const topPos = tab.position().top + tab.outerHeight() - offset;

  if (row % 2 === 0) {
    // 偶数行 → indicator2
    $(".js-nav-tab .is-indicator").css({ opacity: 0 });
    $(".js-nav-tab .is-indicator2").css({
      opacity: 1,
      top: topPos,
      width: tab.outerWidth(),
      left: tab.position() ? tab.position().left : 0,
    });
  } else {
    // 奇数行 → indicator
    $(".js-nav-tab .is-indicator2").css({ opacity: 0 });
    $(".js-nav-tab .is-indicator").css({
      opacity: 1,
      top: topPos,
      bottom: "auto",
      width: tab.outerWidth(),
      left: tab.position() ? tab.position().left : 0,
    });
  }
  tab = tab + 1;
}
  
  let numberIndex = 0;
  $(window).on("load", function () {
    if ($(".js-nav-tab")) {
      if (document.getElementById("repcarepage")) {
        handleTabChangeHowto($(".js-nav-tab li.active"), 0);
      } else {
        handleTabChange($(".js-nav-tab li.active"));
      }
    }
  });

$(document).on("click", ".js-nav-tab li", function () {
  numberIndex = $(this).index();

  if (!$(this).is("active")) {
    $(".js-nav-tab li").removeClass("active");
    $(".js-content-tab").removeClass("active");
    // tab
    $(this).addClass("active");
    handleTabChange($(this));
    if (document.getElementById("repcarepage")) {
      handleTabChangeHowto($(this), numberIndex);
    } else {
      handleTabChange($(".js-nav-tab li.active"));
    }
    // content
    $(".js-content-tab:eq(" + numberIndex + ")").addClass("active");
  }
});

  /* --------------------------------- contact -------------------------------- */

  if ($("#contactpage")) {
    // handle checkbox
    $("#js-checkbox").change(function () {
      let isCheck = this.checked;
      if (isCheck) {
        $(this).addClass("active");
        $(this)
          .closest("#js-contact-form")
          .find(".js-contact-confirm")
          .addClass("active");
      } else {
        $(this).removeClass("active");
        $(this)
          .closest("#js-contact-form")
          .find(".js-contact-confirm")
          .removeClass("active");
      }
    });

    // handle clear
    $(".js-contact-clear").click(function () {
      $("#js-contact-form").find("input, textarea").val("");
    });
  }

  /* ------------------------------ scroll to top ----------------------------- */

  $(".js-scrollTop").click(function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  /* ------------------------------ stockist page ----------------------------- */

  if (document.getElementById("stockist")) {
    let filterActive;

    function filterCategory(category) {
      if (filterActive != category) {
        // reset results list
        $("li.stockist_items").removeClass("active");

        // elements to be filtered
        $("li.stockist_items")
          .filter('[data-tag="' + category + '"]')
          .addClass("active");

        // reset active filter
        filterActive = category;
        $(".js-stockist-option").removeClass("active");
      }
    }

    $(window).on("pageshow load", function () {
      const hash = window.location.hash.substring(1);

      if (hash == "") {
        $(".js-stockist-option").addClass("active");
        $("li.stockist_items").addClass("active");
      } else {
        $("li.stockist_items")
          .filter('[data-tag="' + hash + '"]')
          .addClass("active");
        $(".js-stockist-option")
          .filter('[data-filter-tag="' + hash + '"]')
          .addClass("active");
      }
    });

    $(".js-stockist-option").click(function () {
      filterCategory($(this).attr("data-filter-tag"));
      $(this).addClass("active");
    });
  }

  /* ------------------------------ brands page ----------------------------- */

  if (document.getElementById("brandspage")) {
    //
    $(window).on("pageshow scroll", function () {
      let scroll = $(window).scrollTop();
      let sections = $(".js-brand-section"),
        nav = $(".js-brand-nav"),
        nav_height = nav.outerHeight();

      //
      scroll > 50
        ? $(".js-brand-nav").addClass("invert")
        : $(".js-brand-nav").removeClass("invert");
      if (scroll + window.innerHeight - 200 >= $(".c-footer").offset().top) {
        $(".js-brand-nav").addClass("ishide");
        $(".js-brand-logo").addClass("ishide");
      } else {
        $(".js-brand-nav").removeClass("ishide");
        $(".js-brand-logo").removeClass("ishide");
      }
      //
      nav.find("a").removeClass("active");
      sections.each(function () {
        let top = $(this).offset().top - nav_height,
          bottom = top + $(this).outerHeight();
        if (scroll >= top && scroll <= bottom) {
          nav.find("a").removeClass("active");
          nav.find('a[href="#' + $(this).attr("id") + '"]').addClass("active");
        }
      });
    });

    //
    const offer = document.querySelectorAll(".making_counter .current");
    const total = document.querySelectorAll(".making_counter .total");
    const swiperBrand = new Swiper(".js-brand-swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      effect: "fade",
      speed: 1200,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      loop: true,
      breakpoints: {
        0: {
          allowTouchMove: true,
        },
        1025: {
          allowTouchMove: false,
        },
      },
      on: {
        init: function (sw) {
          $(".making_progress").removeClass("animate");
          $(".making_progress").addClass("animate");
          total.forEach((sel) => {
            sel.innerHTML = sw.slides.length - 2;
          });
          //
          $("[data-making-slide]").removeClass("active");
          $("[data-making-slide]:eq(" + this.realIndex + ")").addClass(
            "active"
          );
        },
        slideChange: function () {
          let currentSlide = this.realIndex + 1;
          offer.forEach((sel) => {
            if (currentSlide >= 10) {
              sel.innerHTML = currentSlide;
            } else {
              sel.innerHTML = "0" + currentSlide;
            }
          });
          //
          $("[data-making-slide]").removeClass("active");
          $("[data-making-slide]:eq(" + this.realIndex + ")").addClass(
            "active"
          );
        },
        slideChangeTransitionStart: function () {
          $(".making_progress").removeClass("animate");
        },
        slideChangeTransitionEnd: function () {
          $(".making_progress").addClass("animate");
        },
      },
    });
  }
});
